module.exports = __webpack_public_path__ + "static/media/transasia_mototurismo_1.44f28c2e.jpg";